import { ItemType, Item, Styleboard, Article } from './types'

const isAProductImageUrl = (url: string): boolean =>
  !(url.includes('content.hm.com/') || url.includes('windows.net/'))

/**
 *We want the image src to be the same as the one on the PDP for caching.
 *Styleboard image responses don't return call query string anymore, see CRCOM-1308
 * @param {string} styleboardProductImageSrc - The URL from the styleboard response.
 */
export const makePDPlikeSrcFromStyleboardProductImageSrc = (
  styleboardProductImageSrc: string,
): string => {
  if (!isAProductImageUrl(styleboardProductImageSrc)) {
    return styleboardProductImageSrc
  }

  return `${styleboardProductImageSrc}&call=url[file:/product/main]`
}

export const normaliseArticles = (rawArticles: Article[]): void => {
  rawArticles.map((rawArticle) => {
    if (rawArticle.productImage) {
      rawArticle.productImage.url = makePDPlikeSrcFromStyleboardProductImageSrc(
        rawArticle.productImage.url,
      )
    }

    if (rawArticle.images?.alternate?.length) {
      rawArticle.images.alternate.map((alternateImage) => {
        alternateImage.url = makePDPlikeSrcFromStyleboardProductImageSrc(alternateImage.url)
        return alternateImage
      })
    }

    if (rawArticle.images?.selected?.length) {
      rawArticle.images.selected.map((selectedImage) => {
        selectedImage.url = makePDPlikeSrcFromStyleboardProductImageSrc(selectedImage.url)
        return selectedImage
      })
    }

    return rawArticle
  })
}

export const normaliseItemsProductImageSrc = (rawItems: Item[]): void => {
  rawItems.map((rawItem) => {
    if (rawItem.type === ItemType.ARTICLE) {
      if (rawItem.images) {
        rawItem.images.map((rawImage) => {
          rawImage.url = makePDPlikeSrcFromStyleboardProductImageSrc(rawImage.url)
          return rawImage
        })
      }

      normaliseArticles([rawItem.article!])
    }

    return rawItem
  })
}

export const normaliseStyleboards = (rawStyleboards: Styleboard[]): void => {
  rawStyleboards.map((rawStyleboard) => {
    if (isAProductImageUrl(rawStyleboard.image)) {
      rawStyleboard.image = makePDPlikeSrcFromStyleboardProductImageSrc(rawStyleboard.image)
    }

    normaliseItemsProductImageSrc(rawStyleboard.items)

    if (rawStyleboard.similarItems) {
      normaliseArticles(rawStyleboard.similarItems!.articles)
    }

    return rawStyleboard
  })
}
